/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portalsignin_Link_Toast_BodyInputs */



/**
* | output |
* | --- |
* | "No email was sent. Try again once your agency has finished setting up sign-in." |
*
* @param {Portalsignin_Link_Toast_BodyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const portalsignin_link_toast_body = /** @type {((inputs?: Portalsignin_Link_Toast_BodyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portalsignin_Link_Toast_BodyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("No email was sent. Try again once your agency has finished setting up sign-in.")
});